export const VAT_RATE: number = 0.2;
